// src/views/Seguridad/Roles/EliminarRoles.jsx
import React from "react";

/**
 * Modal de eliminación de Rol.
 *
 * Props:
 * - initial: { id, nombre, asignadoA: [] }
 * - onClose(): cerrar modal (sin recargar)
 * - onDeleted(): cerrar modal + recargar listado (solo cuando DELETE fue OK)
 * - onEliminar({id}): ejecuta el fetch DELETE (lo hace el padre)
 */
export default function EliminarRoles({
  initial,
  onClose = () => {},
  onDeleted = () => {},
  onEliminar = async () => {},
}) {
  const asignados = Array.isArray(initial?.asignadoA) ? initial.asignadoA : [];
  const count = asignados.length;

  const [submitting, setSubmitting] = React.useState(false);
  const inflightRef = React.useRef(false);

  /** ========================
   *  ELIMINAR (modo correcto)
   *  ========================
   *
   *  ✔ 1) Cerrar modal ANTES del DELETE
   *  ✔ 2) Ejecutar delete afuera (padre)
   *  ✔ 3) Si DELETE falla → modal automático se ve ahora
   *  ✔ 4) Si DELETE ok → padre refresca tabla
   */
  const handleEliminar = () => {
    if (inflightRef.current || submitting) return;
    inflightRef.current = true;
    setSubmitting(true);

    // 1) Cerramos YA MISMO el modal
    onClose();

    // 2) Ejecutamos el DELETE afuera (el padre recibe el promise)
    onEliminar({ id: initial.id })
      .then(() => {
        // 3) DELETE OK → padre refresca
        onDeleted();
      })
      .catch((e) => {
        // 4) DELETE falla → modal automático de appFetchJson se ve sin overlay
        console.error("Error eliminando rol:", e);
      })
      .finally(() => {
        setSubmitting(false);
        setTimeout(() => (inflightRef.current = false), 0);
      });
  };

  return (
    <div className="page max-w-5xl px-4">
      <h2 className="page-title mb-4">Eliminar Rol</h2>

      <div className="rounded-md border border-gray-200 bg-white px-4 py-4 space-y-4">

        {/* Nombre */}
        <div className="form-row gap-2 items-center">
          <div className="form-label">Rol</div>
          <div className="value font-medium">{initial?.nombre ?? "—"}</div>
        </div>

        {/* Advertencia */}
        {count === 0 ? (
          <div className="text-sm text-gray-700">
            ¿Deseás eliminarlo de forma permanente?
          </div>
        ) : (
          <div className="text-sm text-amber-700">
            <b>Atención:</b> este rol está asignado a <b>{count}</b> usuario
            {count !== 1 ? "s" : ""}.
          </div>
        )}

        {/* Botonera */}
        <div className="mt-2 flex items-center justify-end gap-2">
          <button
            type="button"
            className="btn-fil"
            onClick={onClose}
            disabled={submitting}
          >
            Cancelar
          </button>

          <button
            type="button"
            className="btn-fil"
            onClick={handleEliminar}
            disabled={submitting}
          >
            {submitting ? "Eliminando…" : "Eliminar"}
          </button>
        </div>

      </div>
    </div>
  );
}
